import type { BlockIllustration, Visningslage } from '../types'
import Illustration from './Illustration'

/** Visningsläget i klartext för läraren. Vad som täcks över står i prosan —
 *  etiketten säger bara vilken sorts visning det är. */
const VISNING_ETIKETT: Record<Visningslage, string> = {
  hel: 'Visas hel',
  delvis_dold: 'Delvis dold',
  stegvis: 'Byggs upp del för del',
  framme: 'Ligger framme som stöd',
}

/** Figurer som eleverna ser — på tavlan eller tryckta på ett elevmaterial.
 *  Enbart figuren: visningsläget är lärarens information och skulle avslöja
 *  det som medvetet hålls dolt om det projicerades. */
export function Figurer({ illustrationer }: { illustrationer: BlockIllustration[] }) {
  if (illustrationer.length === 0) return null
  return (
    <>
      {illustrationer.map((ill, i) => (
        <Illustration key={i} src={ill.fil} alt={ill.alt} bildtext={ill.bildtext} />
      ))}
    </>
  )
}

/** Samma figurer i lärarvyn, märkta med hur de ska upp. */
export function LararFigurer({ illustrationer }: { illustrationer: BlockIllustration[] }) {
  if (illustrationer.length === 0) return null
  return (
    <div className="stegfigurer">
      {illustrationer.map((ill, i) => (
        <figure key={i} className="stegfigur">
          <span className={`visning-badge visning-badge-${ill.visning}`}>{VISNING_ETIKETT[ill.visning] ?? ill.visning}</span>
          {/* Vad som täcks över är lärarens göra och står bara här. */}
          {ill.overtackning && (
            <p className="figur-overtackning">
              <strong>Täck över: </strong>
              {ill.overtackning}
            </p>
          )}
          <Illustration src={ill.fil} alt={ill.alt} bildtext={ill.bildtext} />
        </figure>
      ))}
    </div>
  )
}
